import { RSAA } from 'redux-api-middleware';

import { getGeolocation } from '../../utils/helper/page-behavior-helper';
import UrlHelper from '../../utils/helper/url-helper';
import { getRequestAdditionalHeader } from './util-actions';
import reduxStore from '../store';

export const DEVICE = '/customer/device';
export const DEVICE_SUCCESS = '/customer/device/success';
export const DEVICE_FAILURE = '/customer/device/failure';

export const FIND_CURRENT_LOAN = '/customer/loan/current';
export const FIND_CURRENT_LOAN_SUCCESS = '/customer/loan/current/success';
export const FIND_CURRENT_LOAN_FAILURE = '/customer/loan/current/failure';

export const AUTO_APPROVAL = '/customer/loan/auto-approval';
export const AUTO_APPROVAL_SUCCESS = '/customer/loan/auto-approval/success';
export const AUTO_APPROVAL_FAILURE = '/customer/loan/auto-approval/failure';

export const FIND_ALL_LOAN = '/customer/loan/all';
export const FIND_ALL_LOAN_SUCCESS = '/customer/loan/all/success';
export const FIND_ALL_LOAN_FAILURE = '/customer/loan/all/failure';

export const FIND_BILL = '/loan/current/re-payments/';
export const FIND_BILL_SUCCESS = '/customer/bill/success';
export const FIND_BILL_FAILURE = '/customer/bill/failure';

export const BANK_DOCUMENT_SEND = '/customer/bank-document/send/';
export const BANK_DOCUMENT_SEND_SUCCESS = '/customer/bank-document/send/success';
export const BANK_DOCUMENT_SEND_FAILURE = '/customer/bank-document/send/failure';

export const INSTALLMENT_SIMULATION = '/customer/installment/simulation';
export const INSTALLMENT_SIMULATION_SUCCESS = '/customer/installment/simulation/success';
export const INSTALLMENT_SIMULATION_FAILURE = '/customer/installment/simulation/failure';

export const INSTALLMENT_UPDATE = '/customer/installment/update';
export const INSTALLMENT_UPDATE_SUCCESS = '/customer/installment/update/success';
export const INSTALLMENT_UPDATE_FAILURE = '/customer/installment/update/failure';

export const GET_MESSAGE_PREFERENCES = '/customer/get-message-preferences';
export const GET_MESSAGE_PREFERENCES_SUCCESS = '/customer/get-message-preferences/success';
export const GET_MESSAGE_PREFERENCES_FAILURE = '/customer/get-message-preferences/failure';

export const UPDATE_MESSAGE_PREFERENCES = '/customer/update-message-preferences';
export const UPDATE_MESSAGE_PREFERENCES_SUCCESS = '/customer/update-message-preferences/success';
export const UPDATE_MESSAGE_PREFERENCES_FAILURE = '/customer/update-message-preferences/failure';

export const GET_UNDERWRITING = '/customer/get-underwriting';
export const GET_UNDERWRITING_SUCCESS = '/customer/get-underwriting/success';
export const GET_UNDERWRITING_FAILURE = '/customer/get-underwriting/failure';

export const FIND_MESSAGES = '/customer/chat/find-messages';
export const FIND_MESSAGES_SUCCESS = '/customer/chat/find-messages/success';
export const FIND_MESSAGES_FAILURE = '/customer/chat/find-messages/failure';

export const SEND_MESSAGE = '/customer/chat/send-message';
export const SEND_MESSAGE_SUCCESS = '/customer/chat/send-message/success';
export const SEND_MESSAGE_FAILURE = '/customer/chat/send-message/failure';
export const SUBMIT_EVALUATION = '/customer/evaluation';
export const SUBMIT_EVALUATION_SUCCESS = '/customer/evaluation/success';
export const SUBMIT_EVALUATION_FAILURE = '/customer/evaluation/failure';

export const REQUEST_APP_INSTALLATION_MESSAGE = '/personal-lending/loan/customer/app-installation-message';
export const REQUEST_APP_INSTALLATION_SUCCESS = '/personal-lending/loan/customer/app-installation-message/success';
export const REQUEST_APP_INSTALLATION_FAILURE = '/personal-lending/loan/customer/app-installation-message/failure';

export const SIGN_INSURANCE = '/customer/sign/insurance';
export const SIGN_INSURANCE_SUCCESS = '/customer/sign/insurance/success';
export const SIGN_INSURANCE_FAILURE = '/customer/sign/insurance/failure';

export const GET_INSURANCE_INFO = '/customer/insurance/info';
export const GET_INSURANCE_INFO_SUCCESS = '/customer/insurance/info/success';
export const GET_INSURANCE_INFO_FAILURE = '/customer/insurance/info/failure';

export const CANCEL_INSURANCE = '/customer/insurance/cancel';
export const CANCEL_INSURANCE_SUCCESS = '/customer/insurance/cancel/success';
export const CANCEL_INSURANCE_FAILURE = '/customer/insurance/cancel/failure';

export const PARTNER_BANNER = '/partner/banner';
export const PARTNER_BANNER_SUCCESS = '/partner/banner/success';
export const PARTNER_BANNER_FAILURE = '/partner/banner/failure';

export const PARTNER_CURRENT_UTM = '/partner/current/utm';
export const PARTNER_CURRENT_UTM_SUCCESS = '/partner/current/utm/success';
export const PARTNER_CURRENT_UTM_FAILURE = '/partner/current/utm/failure';

export const GET_COLLATERAL_RELEASE_CODE = '/customer/collateral-release-code';
export const GET_COLLATERAL_RELEASE_CODE_SUCCESS = '/customer/collateral-release-code/success';
export const GET_COLLATERAL_RELEASE_CODE_FAILURE = '/customer/collateral-release-code/failure';

export const GET_MULTIPLIK_INDICATOR_NAME = '/customer/multiplik/indicator-name';
export const GET_MULTIPLIK_INDICATOR_NAME_SUCCESS = '/customer/multiplik/indicator-name/success';
export const GET_MULTIPLIK_INDICATOR_NAME_FAILURE = '/customer/multiplik/indicator-name/failure';

export const GET_NEAREST_SELLERS = '/customer/loan/nearest/sellers';
export const GET_NEAREST_SELLERS_SUCCESS = '/customer/loan/nearest/sellers/success';
export const GET_NEAREST_SELLERS_FAILURE = '/customer/loan/nearest/sellers/failure';

export const GET_UNICO_URL = '/customer/unico/url';
export const GET_UNICO_URL_SUCCESS = '/customer/unico/url/success';
export const GET_UNICO_URL_FAILURE = '/customer/unico/url/failure';

export const GET_BANK_INFORMATION_BY_PIX_KEY = '/customer/bank-information-by-pix';
export const GET_BANK_INFORMATION_BY_PIX_KEY_SUCCESS = '/customer/bank-information-by-pix/success';
export const GET_BANK_INFORMATION_BY_PIX_KEY_FAILURE = '/customer/bank-information-by-pix/failure';

export const SEND_APPLICATION_LINK = '/customer/send-application-link';
export const SEND_APPLICATION_LINK_SUCCESS = '/customer/send-application-link/success';
export const SEND_APPLICATION_LINK_FAILURE = '/customer/send-application-link/failure';

export const FIND_CUSTOMER_BLOCK_STATE = '/customer/get-customer-block-state';
export const FIND_CUSTOMER_BLOCK_STATE_SUCCESS = '/customer/get-customer-block-state/success';
export const FIND_CUSTOMER_BLOCK_STATE_FAILURE = '/customer/get-customer-block-state/failure';

export const MATCH_DATA_FROM_THE_USER = '/customer/process-customer/user';
export const MATCH_DATA_FROM_THE_USER_SUCCESS = '/customer/process-customer/user/success';
export const MATCH_DATA_FROM_THE_USER_FAILURE = '/customer/process-customer/user/failure';

export const GET_EBS_URL = '/customer/loan/application/ebs-url';
export const GET_EBS_URL_SUCCESS = '/customer/loan/application/ebs-url/success';
export const GET_EBS_URL_FAILURE = '/customer/loan/application/ebs-url/failure';

/**
 * Retrieves or creates a device.
 */
export function getOrCreateDevice(device) {
  getGeolocation();

  return {
    [RSAA]: {
      endpoint: `/api/customer/device`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device: {
            kind: device?.kind,
            code: device?.code,
          },
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(device),
      types: [DEVICE, DEVICE_SUCCESS, DEVICE_FAILURE],
    },
  };
}

/**
 * Finds the current loan for a customer.
 */
export function findCurrentLoan(device) {
  getGeolocation();
  const confirmApplication = window.location.search.includes('confirmApplication');
  return {
    [RSAA]: {
      endpoint: `/api/customer/loan/current?confirmApplication=${confirmApplication}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [
        FIND_CURRENT_LOAN,
        {
          type: FIND_CURRENT_LOAN_SUCCESS,
          payload: (action, state, res) =>
            res
              .text()
              .then((response) => {
                if (!response) {
                  return undefined;
                }
                const loan = JSON.parse(response);
                return loan || undefined;
              })
              .catch(() => undefined),
        },
        FIND_CURRENT_LOAN_FAILURE,
      ],
    },
  };
}

export function getIsAutoApproval(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/loan/auto-approval`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [AUTO_APPROVAL, AUTO_APPROVAL_SUCCESS, AUTO_APPROVAL_FAILURE],
    },
  };
}

export function createRecurrent(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/loan/recurrent-new`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [FIND_CURRENT_LOAN, FIND_CURRENT_LOAN_SUCCESS, FIND_CURRENT_LOAN_FAILURE],
    },
  };
}

export function sendBankDocument(installmentNumber, amount, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/sendBankDocument`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        installmentNumber,
        amount,
      }),
      types: [BANK_DOCUMENT_SEND, BANK_DOCUMENT_SEND_SUCCESS, BANK_DOCUMENT_SEND_FAILURE],
    },
  };
}

export function getInstallmentSimulation(installmentNumber, date, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/installment/simulate?date=${date}&installmentNumber=${installmentNumber}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [INSTALLMENT_SIMULATION, INSTALLMENT_SIMULATION_SUCCESS, INSTALLMENT_SIMULATION_FAILURE],
    },
  };
}

export function updateInstallment(installmentNumber, date, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/installment/update?date=${date}&installmentNumber=${installmentNumber}`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [INSTALLMENT_UPDATE, INSTALLMENT_UPDATE_SUCCESS, INSTALLMENT_UPDATE_FAILURE],
    },
  };
}

export function getMessagePreferences() {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/get-message-preferences`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_MESSAGE_PREFERENCES, GET_MESSAGE_PREFERENCES_SUCCESS, GET_MESSAGE_PREFERENCES_FAILURE],
    },
  };
}

export function updateMessagePreferences(newPreferences) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/update-message-preferences`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        ...newPreferences,
      }),
      types: [UPDATE_MESSAGE_PREFERENCES, UPDATE_MESSAGE_PREFERENCES_SUCCESS, UPDATE_MESSAGE_PREFERENCES_FAILURE],
    },
  };
}

export function findMessages() {
  return {
    [RSAA]: {
      endpoint: `/api/customer-chat/search`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      types: [FIND_MESSAGES, FIND_MESSAGES_SUCCESS, FIND_MESSAGES_FAILURE],
    },
  };
}

export function sendMessage(message) {
  return {
    [RSAA]: {
      endpoint: `/api/customer-chat/send`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        message,
      }),
      types: [SEND_MESSAGE, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE],
    },
  };
}

export function submitEvaluation(evaluations) {
  return {
    [RSAA]: {
      endpoint: `/api/customer/evaluation`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify(evaluations).replace(/"\s+|\s+"/g, '"'),
      types: [SUBMIT_EVALUATION, SUBMIT_EVALUATION_SUCCESS, SUBMIT_EVALUATION_FAILURE],
    },
  };
}

/*
 * Request app installation instructions message
 */
export function requestAppInstallationMessage(messageKind, recipient, device) {
  return {
    [RSAA]: {
      endpoint: `/api/customer/app-installation-message?messageKind=${messageKind}&recipient=${recipient}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({ device, request: getRequestAdditionalHeader() }),
      },
      types: [REQUEST_APP_INSTALLATION_MESSAGE, REQUEST_APP_INSTALLATION_SUCCESS, REQUEST_APP_INSTALLATION_FAILURE],
    },
  };
}

export function signInsurance(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/sign/insurance`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [SIGN_INSURANCE, SIGN_INSURANCE_SUCCESS, SIGN_INSURANCE_FAILURE],
    },
  };
}

export function getInsuranceInfo() {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/insurance/info`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_INSURANCE_INFO, GET_INSURANCE_INFO_SUCCESS, GET_INSURANCE_INFO_FAILURE],
    },
  };
}

export function cancelInsurance(device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/insurance/cancel`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [CANCEL_INSURANCE, CANCEL_INSURANCE_SUCCESS, CANCEL_INSURANCE_FAILURE],
    },
  };
}

export function shouldDisplayPartnerBanner() {
  return {
    [RSAA]: {
      endpoint: `/api/partner/banner`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [PARTNER_BANNER, PARTNER_BANNER_SUCCESS, PARTNER_BANNER_FAILURE],
    },
  };
}

export function getLoanCurrentUtm() {
  return {
    [RSAA]: {
      endpoint: `/api/partner/current/utm`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [PARTNER_CURRENT_UTM, PARTNER_CURRENT_UTM_SUCCESS, PARTNER_CURRENT_UTM_FAILURE],
    },
  };
}

export function getReleaseCodeToOfflineRelease(hour, date, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/collateral-release-code?hour=${hour}&date=${date}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_COLLATERAL_RELEASE_CODE, GET_COLLATERAL_RELEASE_CODE_SUCCESS, GET_COLLATERAL_RELEASE_CODE_FAILURE],
    },
  };
}

export function getNearestSellers(zipCode) {
  getGeolocation();
  const device = reduxStore?.getState()?.customer?.device;
  return {
    [RSAA]: {
      endpoint: `/api/seller/location/nearest-sellers?limit=10&zipCode=${zipCode || ''}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_NEAREST_SELLERS, GET_NEAREST_SELLERS_SUCCESS, GET_NEAREST_SELLERS_FAILURE],
    },
  };
}

export function getMultiplikIndicatorNameByPartyId(partyId, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/multiplik/indicator-name?partyId=${partyId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [GET_MULTIPLIK_INDICATOR_NAME, GET_MULTIPLIK_INDICATOR_NAME_SUCCESS, GET_MULTIPLIK_INDICATOR_NAME_FAILURE],
    },
  };
}

export function sendApplicationLinkWithToken(messageKind, recipient, source, campaign, medium, content) {
  getGeolocation();

  const urlParams = UrlHelper.buildUrlParamsWithUtms(source, campaign, medium, content);

  return {
    [RSAA]: {
      endpoint: `/api/customer/send-application-link?messageKind=${messageKind}` + (urlParams ? `&${urlParams}` : ''),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        emailAddress: recipient?.emailAddress,
        phoneNumber: recipient?.phoneNumber,
        taxId: recipient?.taxId,
      }),
      types: [SEND_APPLICATION_LINK, SEND_APPLICATION_LINK_SUCCESS, SEND_APPLICATION_LINK_FAILURE],
    },
  };
}

export function getCustomerBLockState(customerId, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/get-customer-block-state?customerId=${customerId}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [FIND_CUSTOMER_BLOCK_STATE, FIND_CUSTOMER_BLOCK_STATE_SUCCESS, FIND_CUSTOMER_BLOCK_STATE_FAILURE],
    },
  };
}

export function matchDataFromTheUser(emailAddress, phoneNumber, taxId) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/customer/process-customer`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          request: getRequestAdditionalHeader(),
        }),
      },
      body: JSON.stringify({
        emailAddress,
        phoneNumber,
        taxId,
      }),
      types: [MATCH_DATA_FROM_THE_USER, MATCH_DATA_FROM_THE_USER_SUCCESS, MATCH_DATA_FROM_THE_USER_FAILURE],
    },
  };
}

export function getEbsUrl(taxId, pageToRedirect, device) {
  getGeolocation();
  return {
    [RSAA]: {
      endpoint: `/api/loan/application/ebs-url?taxId=${taxId}&pageToRedirect=${pageToRedirect}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SuperSim-Persistent-Log': JSON.stringify({
          device,
          request: getRequestAdditionalHeader(),
        }),
      },
      types: [
        GET_EBS_URL,
        {
          type: GET_EBS_URL_SUCCESS,
          payload: async (action, state, response) => {
            try {
              return await response.text();
            } catch (error) {
              return '';
            }
          },
        },
        GET_EBS_URL_FAILURE,
      ],
    },
  };
}
